<template>
    <div>
        <h4>Etape 2 - Groupe d'annonces</h4>
        <b-form-group v-for="(group, groupIndex) in adGroups" :key="groupIndex" class="mb-2">
            <div class="d-flex justify-content-between align-items-center cursor-pointer" @click="toggleCollapse(groupIndex)">
                <strong>Groupe {{ groupIndex + 1 }} : {{ group.name || 'Nouveau groupe' }}</strong>
                <feather-icon :icon="openCollapse[groupIndex] ? 'ChevronsUpIcon' : 'ChevronsDownIcon'" />
            </div>
            <b-collapse :id="'collapse-' + groupIndex" v-model="openCollapse[groupIndex]">
                <div>
                    <label> Nom du groupe d'annonces : </label>
                    <b-form-input v-model="group.name" type="text" />
                </div>
                <div>
                    <label> Mots-clés : </label>
                    <b-form-textarea v-model="group.keywords" placeholder="Entrer des mots clés séparés par des virgules" />
                </div>
                <div v-for="(ad, adIndex) in group.ads" :key="adIndex" class="d-flex align-items-center mt-1">
                    <span class="mr-2">{{ ad.titles[0] }}</span>
                    <b-button variant="none" @click="$emit('editAd', groupIndex, adIndex)" class="edit-icon">✎</b-button>
                </div>

                <div class="d-flex justify-content-between w-100 mt-1">
                    <b-button variant="primary" @click="$emit('addAd', groupIndex)" :disabled="!group.name || !group.keywords"> + Annonce </b-button>
                    <b-button variant="danger" v-if="groupIndex != 0" @click="$emit('deleteAdGroup', groupIndex)">- Groupe annonce</b-button>
                </div>
            </b-collapse>
        </b-form-group>

        <b-button variant="primary" class="mt-3 mb-4 float-right" @click="$emit('addAdGroup')" :disabled="disableBtn">+ Groupe annonce</b-button>

        <div class="d-flex justify-content-between w-100">
            <b-button variant="secondary" @click="$emit('back')">Précédent</b-button>
            <b-button variant="primary" class="ml-2" v-if="spinner" disabled>
                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            </b-button>
            <b-button variant="primary" class="ml-2" @click="$emit('create')" :disabled="disableBtn" v-else>Créer</b-button>
        </div>
    </div>
</template>
<script>
    import { BCollapse } from 'bootstrap-vue';
    import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
    export default {
        components: {
            BCollapse,
            FeatherIcon,
        },
        props: {
            adGroups: {
                type: Array,
            },
            currentAdGroupIndex: {
                type: Number,
            },
            spinner: {
                type: Boolean,
            },
        },
        data() {
            return {
                openCollapse: [],
            };
        },
        computed: {
            disableBtn() {
                let disable = false;
                for (const group of this.adGroups) {
                    if (!group.name || !group.keywords || !group.ads.length) {
                        disable = true;
                    }
                }
                return disable;
            },
        },
        mounted() {
            this.openCollapse = this.adGroups.map((_, i) => i === this.currentAdGroupIndex);
        },
        watch: {
            adGroups(newGroups) {
                this.openCollapse = newGroups.map((_, i) => i === newGroups.length - 1);
            },
        },
        methods: {
            toggleCollapse(index) {
                this.openCollapse = this.openCollapse.map((_, i) => (i === index ? !this.openCollapse[i] : false));
            },
        },
    };
</script>
<style scoped>
    .edit-icon {
        transform: rotate(90deg);
        font-size: 20px;
        padding: 5px;
    }
</style>
